module.exports = __webpack_public_path__ + "img/serve5.d9d7ee47.png";